import slugify from 'slugify';
import axios from 'axios';
import isObject from 'lodash/isObject';
//import { parse, evaluate } from 'groq-js';;

/**
 * Get classes.
 *
 * @param {string}  query. Optional.
 * @return {array}
 */
// export const queryClasses = async query => {
//
//   const sfClasses = require( 'data/globals/sf-classes' );
//
//   if( ! query ) {
//     return sfClasses;
//   }
//
//   const tree = parse( query );
//   const value = await evaluate( tree, { dataset: sfClasses } );
//   const result = await value.get();
//
//   return result;
//
// }

/**
 * Get shortened salesforce ID.
 *
 * @param {string} id
 * @return {string} shortened 15 character id.
 */
export const getShortID = id => id.substring( 0, 15 );

/**
 * Get class city slug,
 *
 * @param {object}  c.
 * @param {bool}    reverse.
 * @return string.
 */
export const getClassCitySlug = ( c, reverse = false ) => {

  let slug = null;
  let city = null;

  if( c.Location_State__c && c.Location_City__c ) {
    slug = ! reverse ? slugify( `${c.Location_State__c}-${c.Location_City__c}` ) : slugify( `${c.Location_City__c}-${c.Location_State__c}` ) ;
    city = slug
    .replace( /\(/g, '' )
    .replace( /\)/g, '' )
    .toLowerCase();
  }

  return city;

}

/**
 * Get city slug.
 *
 * @param {string|object}   param
 * @param {bool}            reverse
 * @return {string}
 */
export const getCitySlug = ( param, reverse ) => {

  let slug = null;
  if( isObject( param ) ) {
    slug = getClassCitySlug( param, reverse );
  }
  else {
    const state = param.substring( 0, 2 );
    const cityName = param.substring( 5 );

    if( !! reverse ) {
      slug = slugify( `${state}-${cityName}` )
      .replace( /\(/g, '' )
      .replace( /\)/g, '' )
      .toLowerCase();
    }
    else {
      slug = slugify( `${cityName}-${state}` )
      .replace( /\(/g, '' )
      .replace( /\)/g, '' )
      .toLowerCase();
    }

  }

  return slug;

}

/**
 * Get class time.
 *
 * @param {object}  course.
 * @return {string}
 */
export const getClassTime = course => {

  // weekend.
  if( !! ( course.courses || [] ).length ) {
    return '8:30am - 5pm';
  }

  // standard.
  if( course.days === 1 || ( course.page || {} ).days === 1  ) {
    return '8:30am - 5pm';
  }

}

/**
 * Get classes.
 *
 * @return {array}
 */
export const getClasses = async () => {

  if( typeof window === 'undefined' ) {
    return;
  }

  const cache = sessionStorage.getItem( 'classes' );
  let classes = null;

  if( !! cache ) {
    classes = JSON.parse( cache );
  }
  else {

    if( typeof window === 'undefined' ) {
      return;
    }
    const response = await axios.get( `${window.FUNCTIONS_URL}/sf-classes?soldout=true` );
    classes = response.data;

    if( !! classes && !! classes.length ) {
      sessionStorage.setItem( 'classes', JSON.stringify( classes ) );
    }

  }

  return classes;

}

/**
 * Process class data.
 *
 * @param {array} classes.
 * @param {string} courseIDs.
 * @return {object} containing cities and dates.
 */
export const processClassData = ( classes, courseIDs ) => {

  const updatedDates = {};
  const updatedCities = [];

  if( !! classes.length ) {

    for( let c of classes ) {

      const classID = getShortID( c.Product2__r.Id );

      if( !! courseIDs && ! courseIDs.includes( classID ) ) {
        continue;
      }

      let city = null;
      if( c.Location_State__c && c.Location_City__c ) {
        city = `${c.Location_State__c.toUpperCase()} - ${c.Location_City__c}`;
      }

      if( city && ! updatedCities.includes( city ) ) {
        updatedCities.push( city );
      }


      if( ! updatedDates[classID] ) {
        updatedDates[classID] = [];
      }

      updatedDates[classID].push( c );

    }

    if( !! updatedCities.length ) {
      updatedCities.sort( ( a, b ) => {
        if( a < b ) { return -1; }
        if( a > b ) { return 1; }
        return 0;
      } );
    }

    return( {
      cities: [ ...updatedCities ],
      dates: { ...updatedDates },
    } );

  }


}
